import { P } from "@quarks";
import styled from "styled-components";
import { StyledTextProps } from "./types";

export const StyledText = styled(P).attrs<StyledTextProps>(({ theme, $disabled, ...attrs }) => ({
  ...attrs,
  color: $disabled ? theme.button.text.disabled.color : theme.text.color.body,
}))<StyledTextProps>``;
